"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var _react = _interopRequireDefault(require("react"));
var _Component = require("./Component");
var _state = require("../../../../../state");
var _excluded = ["confirmNewPassword"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Container = function Container() {
  var _useUser = (0, _state.useUser)(),
    user = _useUser.user;
  var _useUpdatePassword = (0, _state.useUpdatePassword)(),
    updatePasswordState = _useUpdatePassword.updatePasswordState,
    updatePassword = _useUpdatePassword.updatePassword;
  return /*#__PURE__*/_react.default.createElement(_Component.Component, {
    submitLoading: updatePasswordState.loading,
    submitSucceeded: updatePasswordState.done,
    currentPasswordFieldVisible: !!(user !== null && user !== void 0 && user.credentials.passwordExists),
    emailConfirmed: user === null || user === void 0 ? void 0 : user.credentials.emailConfirmed,
    onSubmit: function onSubmit(_ref) {
      var _ = _ref.confirmNewPassword,
        rest = _objectWithoutProperties(_ref, _excluded);
      return updatePassword(rest);
    }
  });
};
exports.Container = Container;